<template>
  <div id="project-visit-reserve" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="预约参观" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="project-info">
      <img src="../../assets/icon/icon-address.png">
      <div class="customer-address-info">
        <div>{{projectAddress}}</div>
        <span class="foreman-name">工长<span>{{foremanName}}</span></span>
      </div>
    </div>
    <div class="section-title">基本信息</div>
    <div class="content-form general-box-shadow">
      <div class="appointment-form-item border-bottom-style">
        <div class="form-title">联系人</div>
        <input class="form-input" type="text" v-model="name" placeholder="请输入联系人"/>
        <div class="form-input-box-sex">
          <div class="sex-radio" @click="sexClick(1)">
            <img v-if="sex == 1" src="../../assets/icon/icon-check-box-selected.png">
            <img v-if="sex != 1" src="../../assets/icon/icon-check-box-unselect.png">男
          </div>
          <div class="sex-radio" @click="sexClick(0)">
            <img v-if="sex == 0" src="../../assets/icon/icon-check-box-selected.png">
            <img v-if="sex != 0" src="../../assets/icon/icon-check-box-unselect.png">女
          </div>
        </div>
      </div>
      <div class="appointment-form-item border-bottom-style">
        <div class="form-title">时间</div>
        <input class="form-input time-select" type="text" @click="open('endTimePicker')" readonly="readonly"  v-model="visitTime"  placeholder="选择时间"/>
        <mt-datetime-picker ref="endTimePicker" @confirm="setVisitTime" :startDate="startTime" v-model="visitDateTime" type="datetime" year-format="{value}" month-format="{value}" date-format="{value}" hour-format="{value}" minute-format="{value}">
        </mt-datetime-picker>
        <img class="icon-form-select" src="../../assets/icon/icon-drop-down.png">
      </div>
      <div class="appointment-form-item border-bottom-style">
        <div class="form-title">手机号</div>
        <input class="form-input" type="text" v-model="phone" placeholder="请输入手机号"/>
      </div>
      <div class="appointment-form-item border-bottom-style">
        <div class="form-title">备注</div>
        <input class="form-input" type="text" v-model="remark" placeholder="请输入备注信息"/>
      </div>
      <div v-if="!isEnroll" class="submit-btn" @click="saveVisitReserve()">提交</div>
      <div v-if="isEnroll" class="submit-btn disable">已预约</div>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import customerVisitService from '../../service/customer/CustomerVisitService'

  export default {
    name: 'OnestopReservation',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        projectId:'',
        projectAddress:'',
        foremanName:'',
        visitTime:'',
        startTime:new Date(),
        visitDate:new Date(),
        visitDateTime:new Date(),
        sex:'1',
        name:'',
        phone:'',
        code:'',
        remark:'',
        isWechatBrowser:this.$verfyBrowserType(),
        isEnroll:true
      }
    },
    created(){
      this.projectId =this.$route.query.projectId;
      this.projectAddress = this.$route.query.projectAddress;
      this.foremanName = this.$route.query.foremanName;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.list();

      //增加Date对象方法
      Date.prototype.format = function (fmt) {
        var o = {
          "M+": this.getMonth() + 1, //月份
          "d+": this.getDate(), //日
          "H+": this.getHours(), //小时
          "m+": this.getMinutes(), //分
          "s+": this.getSeconds(), //秒
          "q+": Math.floor((this.getMonth() + 3) / 3), //季度
          "S": this.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
          if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
      }
    },
    methods: {
      async list(){
        let {code,data:visitRecords} = await customerVisitService.list(this.projectId);
        if (code == '0') {
          if(visitRecords.length == 0){
            this.isEnroll = false;
          }
        }
      },
      sexClick(sex){
        this.sex = sex;
      },
      open(picker) {
        this.$refs[picker].open();
      },
      setVisitTime(value) {
        this.visitDate= value;
        this.visitTime = value.format("yyyy-MM-dd HH:mm");
      },
      mobilePhone(){
        var phone = this.phone;
        if (!phone) {
          Toast('请输入手机号码！');
          return false;
        }
        var re = /^1\d{10}$/;
        if (re.test(phone)) {
          return true;
        } else {
          Toast('手机号码格式不正确!');
          return false;
        }
      },
      async saveVisitReserve(){
        if(!this.name){
          Toast('请填写联系人!');
          return;
        }
        if(!this.visitTime){
          Toast('请选择预约时间!');
          return;
        }
        if (!this.mobilePhone()) {
          return;
        }
        let res = await customerVisitService.save({onestopProjectId:this.projectId,name:this.name,phone:this.phone,sex:this.sex,visitTime:this.visitDate,remark:this.remark});
        if (res.code == '0') {
          Toast('预约附近工地成功!');
          this.$router.go(-1);
        } else {
          Toast('预约失败，请稍后再试！');
        }
      },
    }
  }
</script>

<style lang="scss">
  @import '../../assets/style/common.scss';
  #project-visit-reserve{
    padding-bottom: 0.8rem;
    font-size: 0.32rem;
    background-color: white;
    .project-info{
      display: flex;
      height: 1.05rem;
      padding: 0.3rem;
      background-image: url(../../assets/icon-default-top-bg.png);
      font-size: 0.36rem;
      font-weight: bold;
      color: white;
      img{
        width: 0.35rem;
        height: 0.42rem;
      }
      .customer-address-info{
        padding-left: 0.2rem;
        .foreman-name{
          padding-top: 0.3rem;
          font-size: 0.28rem;
          span{
            padding-left: 0.2rem;
            font-size: 0.32rem;
          }
        }
      }
    }
    .section-title{
      padding: 0.3rem 0 0.2rem 0.3rem ;
      font-size: 0.36rem;
      font-weight: bold;
    }
    .content-form{
      width: 6.9rem;
      margin: 0 auto;
      padding-bottom: 0.72rem;
      font-size: 0.28rem;
      color: #333;
      .appointment-form-item{
        width: 6.3rem;
        margin: 0 auto;
        padding-bottom: 0.2rem;
        position: relative;
        .form-title{
          margin-top: 0.3rem;
          margin-bottom: 0.18rem;
          font-size: 0.28rem;
          color: #7f7d7c;
        }
        .form-input{
          font-size: 0.32rem;
          color: #191818;
        }
        .time-select{
          padding-right: 2.6rem;
        }
        .icon-form-select{
          position: absolute;
          right: 0;
          bottom: 0.3rem;
          width: 0.17rem;
          height: 0.13rem;
        }
      }
      .form-input-box-sex{
        position: absolute;
        top: 0.5rem;
        right: 0rem;
        width: 2.12rem;
        font-size: 0.32rem;
        color: #878E99;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .sex-radio{
          display: flex;
          align-items: center;
          img{
            width: 0.37rem;
            height: 0.37rem;
            margin-right: 0.19rem;
          }
        }
      }
      .submit-btn{
        width: 2.8rem;
        height: 0.8rem;
        margin: 1.6rem auto 0;
        text-align: center;
        line-height: 0.83rem;
        background-color: #feac00;
        border-radius: 0.8rem;
        letter-spacing: 4px;
        font-size: 0.36rem;
        color: white;
      }
      .disable{
        background-color:#d0d0d0
      }
    }
  }
</style>


